module.exports = __webpack_public_path__ + "492c6f6088dd46832386dfcc523532b5.jpg";